module.exports = __webpack_public_path__ + "media/images/promotions/cards/fate-5-200bf3331dfb7e3fd749f9b137225d40.svg";